/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AppGoogleSSO_viewer$ref: FragmentReference;
declare export opaque type AppGoogleSSO_viewer$fragmentType: AppGoogleSSO_viewer$ref;
export type AppGoogleSSO_viewer = {|
  +id: string,
  +company: ?{|
    +id: string,
    +googleSSOEnabled: ?boolean,
  |},
  +$refType: AppGoogleSSO_viewer$ref,
|};
export type AppGoogleSSO_viewer$data = AppGoogleSSO_viewer;
export type AppGoogleSSO_viewer$key = {
  +$data?: AppGoogleSSO_viewer$data,
  +$fragmentRefs: AppGoogleSSO_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppGoogleSSO_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "googleSSOEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ad7f9b73cd761dd4203c64123c67abb1';

module.exports = node;
